import React from 'react'

const FabricaContainer = ({ children }) => {
  return <>{children}</>
}

export default FabricaContainer
